import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=1312d4ab&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1312d4ab')) {
      api.createRecord('1312d4ab', component.options)
    } else {
      api.reload('1312d4ab', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=1312d4ab&", function () {
      api.rerender('1312d4ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gb6AQX6ppaYw/JS/offershelp.vue"
export default component.exports